import styled from 'styled-components';

export const TabGroup = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 22px;
  a {
    text-decoration: none;
  }
`;
